import { configureStore, createAction } from '@reduxjs/toolkit'
import { businessLayoutReducer } from './business/reducers/layoutReducer'
import { prescriptionReducer } from './clinic/reducers/prescription/prescriptionReducer'
import { serviceProvidersDataReducer } from './clinic/reducers/serviceProviders/serviceProvidersReducer'
import { genericDataReducer } from './consumer/reducers/genericData/genericDataReducer'
import { personalDataReducer } from './consumer/reducers/personalData/personalDataReducer'
import { bookingRequestReducer } from './mentor/reducers/bookingRequest/bookingRequestReducer'
import { coursesReducer } from './mentor/reducers/courses/coursesReducer'
import { doctorRecommendedHealthEntitiesReducer } from './reducers/doctorRecommendedHealthEntities/doctorRecommendedHealthEntitiesReducer'
import { profileDataReducer } from './reducers/profileData/profileDataReducer'
import { screeningReportTemplateDataReducer } from './reducers/screeningReportTemplate/screeningReportTemplateDataReducer'
import { setupDataReducer } from './reducers/setupData/setupDataReducer'
import { teacherProfileDataReducer } from './reducers/teacherProfileData/teacherProfileDataReducer'
import { supportTherapistsReducer } from './supportPortal/reducers/therapists/genericDataReducer'
import { emrDataReducer } from 'src/reducers/emr/emrReducer'
import { vitalsFormSettingsReducer } from './reducers/vitalsFormSettings/vitalsFormSettingsReducer'

export const resetStores = createAction('resetStores')

export default configureStore({
  reducer: {
    genericDataStore: genericDataReducer,
    personalDataStore: personalDataReducer,
    bookingRequestStore: bookingRequestReducer,
    businessLayoutStore: businessLayoutReducer,
    serviceProvidersDataStore: serviceProvidersDataReducer,
    coursesReducer,
    prescriptionStore: prescriptionReducer,
    emrStore: emrDataReducer,
    supportTherapistsStore: supportTherapistsReducer,

    setupDataStore: setupDataReducer,
    profileDataStore: profileDataReducer,
    teacherProfileDataStore: teacherProfileDataReducer,
    screeningReportTemplateStore: screeningReportTemplateDataReducer,
    doctorRecommendedHealthEntitiesStore: doctorRecommendedHealthEntitiesReducer,
    vitalsFormSettingsStore: vitalsFormSettingsReducer,
    // mentorChamberRoomsStore: mentorChamberRoomsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Increase the warning threshold from 32ms to 100ms
        // This prevents warnings for reasonable serialization times
        warnAfter: 100,
        // Ignore certain action types if needed (uncomment and add as needed)
        // ignoredActions: ['someAction/type'],
        // Ignore certain paths in state if they contain non-serializable data
        // The Agora Chat connection object is a non-serializable SDK instance
        ignoredPaths: ['personalDataStore.agoraChatServerConnection'],
      },
    }),
  devTools: true,
})
